export const leadCaptureFilterOptions = [
  {
    labels: "Created By",
    value: false,
  },
  {
    labels: "Form Name",
    value: false,
  },
  {
    labels: "Created On",
    value: false,
  },
  {
    labels: "Last Submission",
    value: false,
  },
];
